import { Decoder } from '../Utils/js/Decoder';

export const appType = process.env.REACT_APP_APPLICATION_TYPE;
export const client = process.env.REACT_APP_APPLICATION_CLIENT;
export const mfa = process.env.REACT_APP_MFA;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrl2 = process.env.REACT_APP_BASE_URL_2;
export const baseUrl3 = process.env.REACT_APP_BASE_URL_3;
export const apiCommon = process.env.REACT_APP_API_COMMON;
export const apiCommonAutomation = process.env.REACT_APP_API_COMMON_AUTOMATION;
export const apiCommonGet = process.env.REACT_APP_API_COMMON_GET;
export const apiMaterial = process.env.REACT_APP_API_MATERIAL;
export const apiMaterialNA = process.env.REACT_APP_API_MATERIAL_NA;
export const apiAuth = process.env.REACT_APP_API_AUTH;
export const onBoard = process.env.REACT_APP_API_ONBOARD; // use for msem & ltdc
export const onBoardInv = process.env.REACT_APP_API_ONBOARD_INV; // use for stock declaration invoice
export const setUp = process.env.REACT_APP_API_SETUP;
export const invoice = process.env.REACT_APP_API_INVOICE;
export const vendorReg = process.env.REACT_APP_API_VENREG;
export const vendorRegNA = process.env.REACT_APP_API_VENREG_NA;
export const inventory = process.env.REACT_APP_API_INVENTORY;
export const controlling = process.env.REACT_APP_API_CONTROLLING;
export const auction = process.env.REACT_APP_API_AUCTION;
export const vendorInvoice = process.env.REACT_APP_API_VENDOR_INVOICE;
export const jvPowerBI = process.env.REACT_APP_REPORT_JV_DASHBOARD;
export const vendorStatement = process.env.REACT_APP_API_VENDOR_STATEMENT;
export const purchaseOrder = process.env.REACT_APP_API_PURCHASE_ORDER;
export const purchaseOrderNA = process.env.REACT_APP_API_PURCHASE_ORDER_NA;
export const chatUrl = process.env.REACT_APP_API_CHAT;

export const sso_baseUrl = process.env.REACT_APP_API_SSO_BASE_URL;
export const sso_realm = process.env.REACT_APP_API_SSO_REALM;
export const sso_clientId = process.env.REACT_APP_API_SSO_CLIENT_ID;
export const sso_redirectUri = process.env.REACT_APP_API_SSO_REDIRECT_URI;
export const aesSecretKey = process.env.REACT_APP_SECRET_KEY;
export const aesIvKey = process.env.REACT_APP_IV_KEY;
export const isAesEncryptionEnabled = process.env.REACT_APP_AUTHENTICATION_ENABLED;
export const encryption = process.env.REACT_APP_ENCRYPTION;

// uploader download file name
export const uploadSheet = {
  jvUploadSheet: process.env.REACT_APP_JV_UPLOAD_SHEET,
  qr_UploadSheet: process.env.REACT_APP_QR_UPLOAD_SHEET,
  qr_Details_UploadSheet: process.env.REACT_APP_QRD_UPLOAD_SHEET,
  materialUploadSheet: process.env.REACT_APP_MATERIAL_UPLOAD_SHEET,
};

// Get user data from local storage
export const getUserAllData = () => {
  let userAllData = [];
  const userData = Decoder(localStorage.getItem('user_data'));
  const otherData = localStorage.getItem('other_data');
  const appType = process.env.REACT_APP_APPLICATION_TYPE; // Fetch the app type

  if (userData && userData?.VConnectValidate) {
    userAllData = userData?.VConnectValidate?.map(item => ({
      companyId: `${item?.CompanyID}`,
      companyCode: `${item?.CompanyCode}`,
      loginUserId: `${item?.LoginUserID}`,
      userId: `${item?.UserID}`,
      userName: `${item?.UserName}`,
      fullName: `${item?.FullName}`,
      matcAllowSection: `${item?.MATCAllowSection}`,
      dateShort: `${item?.DateShort}`,
      dateLong: `${item?.DateLong}`,
      isVendor: `${item?.IsVendor}`,
      IsAdmin: item?.IsAdmin,
      IsSuperAdmin: item?.IsSuperAdmin,
      sappCompanyCode: `${item?.SappCompanyCode}`,
      departmentCode: `${item?.DepartmentCode}`,
    }));
  } else if (userData && userData?.VConnectVendorValidate) {
    userAllData = userData?.VConnectVendorValidate?.map(item => ({
      companyId: `${item?.CompanyID}`,
      companyCode: `${item?.CompanyCode}`,
      loginUserId: `${item?.LoginUserID}`,
      userId: `${item?.UserID}`,
      vendorCode: `${item?.VendorCode}`,
      panCode: `${item?.PAN}`,
      vendorName: `${item?.VendorName}`,
      VendorID: `${item?.VendorID}`,
      isVendor: `${item?.IsVendor}`,
      userName: `${item.UserName}`,
      fullName: `${item?.FullName}`,
      matcAllowSection: `${item?.MATCAllowSection}`,
      dateShort: `${item?.DateShort}`,
      dateLong: `${item?.DateLong}`,
      RequestNo: `${item?.RequestNo}`,
      VendorTypeID: `${item?.VendorTypeID}`,
      IsIndia: item?.IsIndia,
      VendorType: `${item?.VendorType}`,
      sappCompanyCode: `${item?.SappCompanyCode}`,
      departmentCode: '',
    }));
  } else if (userAllData === undefined || userAllData === null) {
    userAllData = Decoder(localStorage.getItem('user_data'))?.AppAuthConnect?.map(item => {
      return {
        companyId: `${item?.CompanyID}`,
        companyCode: `${item?.CompanyCode}`,
        loginUserId: `${item?.LoginUserID}`,
        userId: `${item?.UserID}`,
        vendorCode: `${item?.VendorCode}`,
        panCode: `${item?.PAN}`,
        vendorName: `${item?.VendorName}`,
        VendorID: `${item?.VendorID}`,
        isVendor: `${item?.IsVendor}`,
        userName: `${item?.UserName}`,
        fullName: `${item?.FullName}`,
        matcAllowSection: `${item?.MATCAllowSection}`,
        dateShort: `${item?.DateShort}`,
        dateLong: `${item?.DateLong}`,
        sappCompanyCode: `${item?.SappCompanyCode}`,
        departmentCode: '',

      };
    });
  }
  if (userData) {
    userAllData[0].IPAddress = otherData;
    userAllData[0].appType = appType;
  }
  return userAllData;
};
